import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=30545e6e"
import script from "./BaseSelector.vue?vue&type=script&lang=js"
export * from "./BaseSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseSelector.vue?vue&type=style&index=0&id=30545e6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports